import client from "../client";

const getAll = () => client.get<any>("/training-categories");
const create = (data: any) => client.post<any>("/training-categories", data);
const update = (id: number, data: any) =>
  client.patch<any>(`/training-categories/${id}`, data);
const remove = (id: number) => client.delete<any>(`/training-categories/${id}`);

const trainingCategoryApi = {
  getAll,
  create,
  update,
  remove,
};
export default trainingCategoryApi;
